// Images for the How It Works page
export const howItWorksHeroImage = "/assets/jpg/Howitworks1.jpg";

// Feature icons
export const createAccountIcon = "/assets/svg/noun-create.svg";
export const invoiceIcon = "/assets/svg/noun-invoice.svg";
export const startupIcon = "/assets/svg/noun-startup.svg";
export const sendDocumentsIcon = "/assets/svg/noun-send-documents.svg";
export const carIcon = "/assets/svg/noun-car.svg";
export const strategyIcon = "/assets/svg/noun-strategy.svg";
export const paymentIcon = "/assets/svg/noun-payment.svg";
export const toolsIcon = "/assets/svg/noun-tools.svg";

// Download icons
export const downloadIcon = "/assets/svg/download.svg";
export const rightArrowIcon = "/assets/svg/arrow-right.svg";

// Background images
export const ctaBackgroundImage = "/assets/jpg/Howitworks2.jpg";
